module.exports = __webpack_public_path__ + "static/media/whitelabels.06cecc3c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/whitelabels.svg
// module id = 464
// module chunks = 5